/** Invite members to the portal, see and revoke access, reset PINs and passwords, decide change requests. */
export const MEMBERS_PORTAL = "members.portal";
/** The club's choices: sign-in methods, directory rules, household visibility, online payment, logo. */
export const PORTAL_SETTINGS = "portal.settings";
/** Record payments; here, deal with online payments the books refused and with refunds and disputes the processor reported. */
export const BILLING_PAYMENTS = "billing.payments";
/** Open the member portal as a member and act for them, with a typed reason ("view as member"). */
export const PORTAL_VIEW_AS_MEMBER = "portal.view_as_member";
/** Reads the audit log, and with it the list of staff views. */
export const AUDIT_READ = "audit.read";
/** See and answer the house-work requests and general messages members send from the portal. */
export const PORTAL_REQUESTS = "portal.requests";
